/**
 * ooo-dose-tabs.js
 * Handles Low Dose / High Dose tab filtering on the Out of Office THC Gummies product page.
 * Low Dose shows: Single, Double, Triple
 * High Dose shows: Quad, Fifteen
 *
 * Root cause of the re-render bug:
 * product-info.js calls updateOptionValues() which replaces the variant-selects DOM
 * with fresh HTML (no ooo-hidden classes) after every variant change, then publishes
 * PUB_SUB_EVENTS.variantChange. We subscribe to that event and re-apply visibility.
 */
(function () {
  if (window.__oooDozeTabsInit) return;
  window.__oooDozeTabsInit = true;

  // Track the active tab so we can restore it after DOM re-renders
  var currentDose = 'low';

  function getFieldset(tabContainer) {
    var variantSelects = tabContainer.closest('variant-selects');
    return variantSelects && variantSelects.querySelector('.product-form__input--pill');
  }

  function updateVisibility(fieldset, activeDose) {
    fieldset.querySelectorAll('[data-ooo-dose-group]').forEach(function (opt) {
      opt.classList.toggle('ooo-hidden', opt.getAttribute('data-ooo-dose-group') !== activeDose);
    });
  }

  // Apply visual appearance matching the SINGLE/DOUBLE/TRIPLE pill buttons exactly
  function applyVisualState(btn, isActive) {
    var s = btn.style;
    // Layout (shared)
    s.setProperty('flex', '1');
    s.setProperty('display', 'inline-flex');
    s.setProperty('flex-direction', 'column');
    s.setProperty('align-items', 'center');
    s.setProperty('white-space', 'normal');
    s.setProperty('line-height', '1.15');
    s.setProperty('padding', '13px 16px');
    s.setProperty('font-family', 'inherit');
    s.setProperty('font-size', '9px');
    s.setProperty('font-weight', '700');
    s.setProperty('letter-spacing', '0.5px');
    s.setProperty('text-transform', 'uppercase');
    // Visual (shared)
    var isCro = !!document.querySelector('[data-cro-pdp]');
    s.setProperty('border', isCro ? '2px solid #013940' : 'none');
    s.setProperty('border-radius', '4px');
    s.setProperty('cursor', 'pointer');
    s.setProperty('transition', 'background 0.15s ease, color 0.15s ease, box-shadow 0.15s ease');
    // Visual (state-dependent)
    // Drop shadow ONLY on the active (pressed) tab — the unpressed tab should look flat.
    if (isActive) {
      s.setProperty('background', '#013940');
      s.setProperty('color', '#fff');
      s.setProperty('box-shadow', '-2px 4px 1px rgba(0,0,0,0.5)');
    } else {
      s.setProperty('background', 'transparent');
      s.setProperty('color', isCro ? '#013940' : 'var(--soul-card-teal, #342808)');
      s.setProperty('box-shadow', 'none');
    }
  }

  function syncTabActiveClass(container, activeDose) {
    container.querySelectorAll('[data-dose-tab]').forEach(function (t) {
      var isActive = t.getAttribute('data-dose-tab') === activeDose;
      t.classList.toggle('ooo-dose-tab--active', isActive);
      applyVisualState(t, isActive);
    });
  }

  function selectFirstVisibleIfNeeded(fieldset, activeDose) {
    var checked = fieldset.querySelector('input[type="radio"]:checked');
    if (!checked) return;
    var wrapper = checked.closest('[data-ooo-dose-group]');
    if (wrapper && wrapper.classList.contains('ooo-hidden')) {
      var firstInput = fieldset.querySelector(
        '[data-ooo-dose-group="' + activeDose + '"] input[type="radio"]:not(.disabled)'
      );
      if (firstInput) firstInput.click();
    }
  }

  function initContainer(container) {
    var fieldset = getFieldset(container);
    if (!fieldset) return;

    // If the initially selected variant is high-dose, activate the high tab
    var checked = fieldset.querySelector('input[type="radio"]:checked');
    var initialDose = 'low';
    if (checked) {
      var wrapper = checked.closest('[data-ooo-dose-group]');
      if (wrapper && wrapper.getAttribute('data-ooo-dose-group') === 'high') {
        initialDose = 'high';
      }
    }

    currentDose = initialDose;
    syncTabActiveClass(container, initialDose);
    updateVisibility(fieldset, initialDose);
  }

  // Tab click handling via event delegation
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-dose-tab]');
    if (!tab) return;
    var container = tab.closest('[data-ooo-dose-tabs]');
    if (!container) return;

    var dose = tab.getAttribute('data-dose-tab');
    currentDose = dose;

    syncTabActiveClass(container, dose);

    var fieldset = getFieldset(container);
    if (!fieldset) return;

    updateVisibility(fieldset, dose);
    selectFirstVisibleIfNeeded(fieldset, dose);
  });

  // Register a preProcessCallback on product-info so the incoming HTML already has
  // ooo-hidden classes applied before viewTransition inserts it — this eliminates
  // the flicker window between DOM insertion and the variantChange event firing.
  function registerPreProcessCallback() {
    var productInfo = document.querySelector('product-info');
    if (productInfo && typeof productInfo.addPreProcessCallback === 'function') {
      productInfo.addPreProcessCallback(function (html) {
        var fieldset = html.querySelector('.product-form__input--pill');
        if (fieldset && fieldset.querySelector('[data-ooo-dose-group]')) {
          updateVisibility(fieldset, currentDose);
        }
      });
    }
  }

  // After product-info.js replaces the variant-selects DOM (on any variant change),
  // it publishes PUB_SUB_EVENTS.variantChange. Re-apply visibility at that point
  // as a safety net (preProcess callback handles the flicker-free path).
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      var container = document.querySelector('[data-ooo-dose-tabs]');
      if (!container) return;
      syncTabActiveClass(container, currentDose);
      var fieldset = getFieldset(container);
      if (fieldset) updateVisibility(fieldset, currentDose);
    });
  }

  // Initialize – deferred scripts run after DOMContentLoaded, so call directly
  function initAll() {
    document.querySelectorAll('[data-ooo-dose-tabs]').forEach(initContainer);
    registerPreProcessCallback();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
